import { numberOfItemsPerPage } from '../constants/globals.js';

import {
  ADD_REQUEST_FOR_SIGNET_APPROVAL,
  ADD_REQUEST_FOR_SIGNET_APPROVAL_START,
  ADD_REQUEST_FOR_SIGNET_APPROVAL_ERROR,
  UPDATE_REQUEST_FOR_SIGNET_APPROVAL,
  UPDATE_REQUEST_FOR_SIGNET_APPROVAL_START,
  UPDATE_REQUEST_FOR_SIGNET_APPROVAL_ERROR,
  GET_REQUEST_FOR_SIGNET_APPROVAL,
  GET_REQUEST_FOR_SIGNET_APPROVAL_START,
  GET_REQUEST_FOR_SIGNET_APPROVAL_ERROR,
  GET_REQUEST_FOR_SIGNET_APPROVAL_LIST,
  GET_REQUEST_FOR_SIGNET_APPROVAL_LIST_START,
  GET_REQUEST_FOR_SIGNET_APPROVAL_LIST_ERROR,
  DELETE_REQUEST_FOR_SIGNET_APPROVAL,
  DELETE_REQUEST_FOR_SIGNET_APPROVAL_START,
  DELETE_REQUEST_FOR_SIGNET_APPROVAL_ERROR,
  CLEAR_ERROR_REQUEST_FOR_SIGNET,
  GET_REQUEST_FOR_SIGNET_APPROVAL_LIST_PAGEABLE,
  CHANGE_REQUEST_FOR_SIGNET_APPROVAL_STATUS,
  CHANGE_REQUEST_FOR_SIGNET_APPROVAL_STATUS_START,
  CHANGE_REQUEST_FOR_SIGNET_APPROVAL_STATUS_ERROR,
  SET_PROCCESOR_FOR_REQUEST_APPROVAL,
  SET_PROCCESOR_FOR_REQUEST_APPROVAL_START,
  SET_PROCCESOR_FOR_REQUEST_APPROVAL_ERROR,
  GET_REQUEST_FOR_SIGNET_APPROVAL_ATTACHMENT_LIST,
  GET_REQUEST_FOR_SIGNET_APPROVAL_ATTACHMENT_LIST_START,
  GET_REQUEST_FOR_SIGNET_APPROVAL_ATTACHMENT_LIST_ERROR,
  DOWNLOAD_REQUEST_FOR_SIGNET_APPROVAL_ATTACHMENT_START,
  DOWNLOAD_REQUEST_FOR_SIGNET_APPROVAL_ATTACHMENT_ERROR,
  GET_REQUEST_FOR_SIGNET_APPROVAL_FILTER_LIST,
  GET_REQUEST_FOR_SIGNET_APPROVAL_FILTER_LIST_START,
  GET_REQUEST_FOR_SIGNET_APPROVAL_FILTER_LIST_ERROR,
  CREATE_REQUEST_FOR_SIGNET_APPROVAL_REFERENCE_NUMBER,
  CREATE_REQUEST_FOR_SIGNET_APPROVAL_REFERENCE_NUMBER_START,
  CREATE_REQUEST_FOR_SIGNET_APPROVAL_REFERENCE_NUMBER_ERROR,
  GET_REQUEST_FOR_SIGNET_APPROVAL_BY_PROCESSOR_LIST,
  GET_REQUEST_FOR_SIGNET_APPROVAL_BY_PROCESSOR_LIST_START,
  GET_REQUEST_FOR_SIGNET_APPROVAL_BY_PROCESSOR_LIST_ERROR,
  GET_REQUEST_FOR_SIGNET_APPROVAL_BY_CLIENT_LIST,
  GET_REQUEST_FOR_SIGNET_APPROVAL_BY_CLIENT_LIST_START,
  GET_REQUEST_FOR_SIGNET_APPROVAL_BY_CLIENT_LIST_ERROR,
  GET_REQUEST_FOR_SIGNET_APPROVAL_BY_INSPECTOR_LIST,
  GET_REQUEST_FOR_SIGNET_APPROVAL_BY_INSPECTOR_LIST_START,
  GET_REQUEST_FOR_SIGNET_APPROVAL_BY_INSPECTOR_LIST_ERROR,
} from '../actions/types';

const initialState = {
  requestForSignetApprovalList: [],
  requestForSignetApproval: {},
  loading: false,
  error: undefined,
  totalElements: '',
  requestForSignetApprovalAttachmentList: [],
};

const clearError = (state) => {
  return {
    ...state,
    error: undefined,
  };
};

const addRequestForSignetApprovalStart = (state) => {
  return {
    ...state,
    error: undefined,
  };
};

const updateRequestForSignetApprovalStart = (state) => {
  return {
    ...state,
    error: undefined,
  };
};

const findAllRequestForSignetsApprovalsStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const findAllRequestForSignetApprovalAttachmentStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const findRequestForSignetApprovalByIdStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const deleteRequestForSignetApprovalStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const downloadRequestForSignetApprovalAttachmentStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const addRequestForSignetApprovalError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const updateRequestForSignetApprovalError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findAllRequestForSignetsApprovalsError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findRequestForSignetApprovalByIdError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const deleteRequestForSignetApprovalError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const downloadRequestForSignetApprovalAttachmentError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findAllRequestForSignetApprovalAttachmentError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const addRequestForSignetApproval = (state, action) => {
  return {
    ...state,
    loading: false,
    requestForSignetApprovalList: [action.payload].concat(
      state.requestForSignetApprovalList.length === numberOfItemsPerPage
        ? state.requestForSignetApprovalList.filter(
            (req) =>
              req !==
              state.requestForSignetApprovalList[
                state.requestForSignetApprovalList.length - 1
              ]
          )
        : state.requestForSignetApprovalList
    ),
    requestForSignetApproval: action.payload,
    error: undefined,
  };
};

const updateRequestForSignetApproval = (state, action) => {
  return {
    ...state,
    loading: false,
    requestForSignetApprovalList: state.requestForSignetApprovalList.map(
      (requestForSignetApproval) =>
        requestForSignetApproval.id === action.payload.id
          ? action.payload
          : requestForSignetApproval
    ),
    error: undefined,
  };
};

const findAllRequestForSignetsApprovalsPageable = (state, action) => {
  return {
    ...state,
    loading: false,
    requestForSignetApprovalList: action.payload[0],
    numberOfPages: action.payload[1],
    totalElements: action.payload[2],
    error: undefined,
  };
};

const findAllRequestForSignetsApprovals = (state, action) => {
  return {
    ...state,
    loading: false,
    requestForSignetApprovalList: action.payload,
    error: undefined,
  };
};

const findAllRequestForSignetApprovalAttachments = (state, action) => {
  return {
    ...state,
    loading: false,
    requestForSignetApprovalAttachmentList: action.payload,
    error: undefined,
  };
};

const findRequestForSignetApprovalById = (state, action) => {
  return {
    ...state,
    loading: false,
    requestForSignetApproval: action.payload,
    error: undefined,
  };
};

const deleteRequestForSignetApproval = (state, action) => {
  return {
    ...state,
    loading: false,
    requestForSignetApprovalList: state.requestForSignetApprovalList.filter(
      (requestForSignetApproval) =>
        requestForSignetApproval.id !== action.payload
    ),
    error: undefined,
  };
};

const changeRequestForSignetApprovalStatus = (state, action) => {
  return {
    ...state,
    loading: false,
    requestForSignetApprovalList: state.requestForSignetApprovalList.map(
      (requestForSignetApproval) =>
        requestForSignetApproval.id === action.payload.id
          ? action.payload
          : requestForSignetApproval
    ),
    requestForSignetApproval: action.payload,
    error: undefined,
  };
};

const changeRequestForSignetApprovalStatusError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const changeRequestForSignetApprovalStatusStart = (state) => {
  return {
    ...state,
    error: undefined,
  };
};

const acceptRequestForSignetApprovalStatus = (state, action) => {
  return {
    ...state,
    loading: false,
    requestForSignetApproval: action.payload,
    error: undefined,
  };
};

const acceptRequestForSignetApprovalStatusError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const acceptRequestForSignetApprovalStatusStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const createRequestForSignetApprovalReferenceNumber = (state, action) => {
  return {
    ...state,
    loading: false,
    requestForSignetApproval: action.payload,
    error: undefined,
  };
};

const createRequestForSignetApprovalReferenceNumberError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const createRequestForSignetApprovalReferenceNumberStart = (state) => {
  return {
    ...state,
    error: undefined,
  };
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_REQUEST_FOR_SIGNET_APPROVAL:
      return addRequestForSignetApproval(state, action);
    case ADD_REQUEST_FOR_SIGNET_APPROVAL_START:
      return addRequestForSignetApprovalStart(state);
    case ADD_REQUEST_FOR_SIGNET_APPROVAL_ERROR:
      return addRequestForSignetApprovalError(state, action);

    case UPDATE_REQUEST_FOR_SIGNET_APPROVAL:
      return updateRequestForSignetApproval(state, action);
    case UPDATE_REQUEST_FOR_SIGNET_APPROVAL_START:
      return updateRequestForSignetApprovalStart(state);
    case UPDATE_REQUEST_FOR_SIGNET_APPROVAL_ERROR:
      return updateRequestForSignetApprovalError(state, action);

    case GET_REQUEST_FOR_SIGNET_APPROVAL:
      return findRequestForSignetApprovalById(state, action);
    case GET_REQUEST_FOR_SIGNET_APPROVAL_START:
      return findRequestForSignetApprovalByIdStart(state);
    case GET_REQUEST_FOR_SIGNET_APPROVAL_ERROR:
      return findRequestForSignetApprovalByIdError(state, action);

    case GET_REQUEST_FOR_SIGNET_APPROVAL_LIST:
      return findAllRequestForSignetsApprovals(state, action);
    case GET_REQUEST_FOR_SIGNET_APPROVAL_LIST_START:
    case GET_REQUEST_FOR_SIGNET_APPROVAL_FILTER_LIST_START:
    case GET_REQUEST_FOR_SIGNET_APPROVAL_BY_PROCESSOR_LIST_START:
    case GET_REQUEST_FOR_SIGNET_APPROVAL_BY_CLIENT_LIST_START:
    case GET_REQUEST_FOR_SIGNET_APPROVAL_BY_INSPECTOR_LIST_START:
      return findAllRequestForSignetsApprovalsStart(state);
    case GET_REQUEST_FOR_SIGNET_APPROVAL_LIST_ERROR:
    case GET_REQUEST_FOR_SIGNET_APPROVAL_FILTER_LIST_ERROR:
    case GET_REQUEST_FOR_SIGNET_APPROVAL_BY_PROCESSOR_LIST_ERROR:
    case GET_REQUEST_FOR_SIGNET_APPROVAL_BY_CLIENT_LIST_ERROR:
    case GET_REQUEST_FOR_SIGNET_APPROVAL_BY_INSPECTOR_LIST_ERROR:
      return findAllRequestForSignetsApprovalsError(state, action);
    case GET_REQUEST_FOR_SIGNET_APPROVAL_LIST_PAGEABLE:
    case GET_REQUEST_FOR_SIGNET_APPROVAL_FILTER_LIST:
    case GET_REQUEST_FOR_SIGNET_APPROVAL_BY_PROCESSOR_LIST:
    case GET_REQUEST_FOR_SIGNET_APPROVAL_BY_CLIENT_LIST:
    case GET_REQUEST_FOR_SIGNET_APPROVAL_BY_INSPECTOR_LIST:
      return findAllRequestForSignetsApprovalsPageable(state, action);

    case DELETE_REQUEST_FOR_SIGNET_APPROVAL:
      return deleteRequestForSignetApproval(state, action);
    case DELETE_REQUEST_FOR_SIGNET_APPROVAL_START:
      return deleteRequestForSignetApprovalStart(state);
    case DELETE_REQUEST_FOR_SIGNET_APPROVAL_ERROR:
      return deleteRequestForSignetApprovalError(state, action);
    case CLEAR_ERROR_REQUEST_FOR_SIGNET:
      return clearError(state);

    case CHANGE_REQUEST_FOR_SIGNET_APPROVAL_STATUS:
      return changeRequestForSignetApprovalStatus(state, action);
    case CHANGE_REQUEST_FOR_SIGNET_APPROVAL_STATUS_START:
      return changeRequestForSignetApprovalStatusStart(state);
    case CHANGE_REQUEST_FOR_SIGNET_APPROVAL_STATUS_ERROR:
      return changeRequestForSignetApprovalStatusError(state, action);

    case SET_PROCCESOR_FOR_REQUEST_APPROVAL:
      return acceptRequestForSignetApprovalStatus(state, action);
    case SET_PROCCESOR_FOR_REQUEST_APPROVAL_START:
      return acceptRequestForSignetApprovalStatusStart(state);
    case SET_PROCCESOR_FOR_REQUEST_APPROVAL_ERROR:
      return acceptRequestForSignetApprovalStatusError(state, action);

    case GET_REQUEST_FOR_SIGNET_APPROVAL_ATTACHMENT_LIST:
      return findAllRequestForSignetApprovalAttachments(state, action);
    case GET_REQUEST_FOR_SIGNET_APPROVAL_ATTACHMENT_LIST_START:
      return findAllRequestForSignetApprovalAttachmentStart(state);
    case GET_REQUEST_FOR_SIGNET_APPROVAL_ATTACHMENT_LIST_ERROR:
      return findAllRequestForSignetApprovalAttachmentError(state, action);

    case DOWNLOAD_REQUEST_FOR_SIGNET_APPROVAL_ATTACHMENT_START:
      return downloadRequestForSignetApprovalAttachmentStart(state);
    case DOWNLOAD_REQUEST_FOR_SIGNET_APPROVAL_ATTACHMENT_ERROR:
      return downloadRequestForSignetApprovalAttachmentError(state, action);

    case CREATE_REQUEST_FOR_SIGNET_APPROVAL_REFERENCE_NUMBER:
      return createRequestForSignetApprovalReferenceNumber(state, action);
    case CREATE_REQUEST_FOR_SIGNET_APPROVAL_REFERENCE_NUMBER_START:
      return createRequestForSignetApprovalReferenceNumberStart(state);
    case CREATE_REQUEST_FOR_SIGNET_APPROVAL_REFERENCE_NUMBER_ERROR:
      return createRequestForSignetApprovalReferenceNumberError(state, action);

    default:
      return state;
  }
}
